import { gql } from '@apollo/client';

export const getCommentsByBarcode = (barCode: string) => {
  return gql`
    {
      readCommentsByBarcode(barCode: ${barCode}) {
        lastUpdatedBy
        createdOn
        comment
      }
    }
  `;
};

export const getTimelineComments = gql`
  query getTimelineComments($verifyId: Float, $barcode: String, $requestId: Float, $po: Float) {
    getTimelineComments(barcode: $barcode, requestId: $requestId, verifyId: $verifyId, po: $po) {
      lastUpdatedBy
      createdBy
      createdOn
      comment
      entryType
    }
  }
`;

export const getCommentsByVerifyId = (verifyId: number) => {
  return gql`
    {
      readCommentsByVerifyId(verifyId: ${verifyId}) {
        lastUpdatedBy
        createdOn
        comment
      }
    }
  `;
};

export const createComment = gql`
  mutation createComment(
    $barcode: String
    $comment: String
    $createdBy: String
    $createdOn: DateTime
    $lastUpdatedBy: String
    $updatedOn: DateTime
    $verifyId: Float!
  ) {
    createComment(
      comment: {
        barcode: $barcode
        comment: $comment
        createdBy: $createdBy
        createdOn: $createdOn
        lastUpdatedBy: $lastUpdatedBy
        updatedOn: $updatedOn
      }
      verifyId: $verifyId
    ) {
      id
    }
  }
`;
